import React from "react";
import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Splash from "./pages/Splash";
import Layout from "./components/Layout";
import Accueil from "./pages/Accueil";
import Horaire from "./pages/Horaire";
import Equipes from "./pages/Equipes";
import Classement from "./pages/Classement";
import Nouvelles from "./pages/Nouvelles";
import Infos from "./pages/Infos";
import TeamDetail from "./pages/TeamDetail";
import Commanditaires from "./pages/Commanditaires";
import DevenirCommanditaire from "./pages/DevenirCommanditaire";
import Galerie from "./pages/Galerie";
import Reglements from "./pages/Reglements";
import Match from "./pages/Match";
import Pointeurs from "./pages/Pointeurs";
import NewsDetail from "./pages/NewsDetail";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import { AuthProvider } from "./lib/auth";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Splash />} />
            <Route element={<Layout />}>
              <Route path="/accueil" element={<Accueil />} />
              <Route path="/horaire" element={<Horaire />} />
              <Route path="/equipes" element={<Equipes />} />
              <Route path="/equipes/:id" element={<TeamDetail />} />
              <Route path="/classement" element={<Classement />} />
              <Route path="/nouvelles" element={<Nouvelles />} />
              <Route path="/nouvelles/:id" element={<NewsDetail />} />
              <Route path="/galerie" element={<Galerie />} />
              <Route path="/commanditaires" element={<Commanditaires />} />
              <Route path="/devenir-commanditaire" element={<DevenirCommanditaire />} />
              <Route path="/infos" element={<Infos />} />
              <Route path="/reglements" element={<Reglements />} />
              <Route path="/match/:num" element={<Match />} />
              <Route path="/pointeurs" element={<Pointeurs />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
